import { ClueSolving } from "../../cluesolving/ClueSolvingBehaviour";
import { CrowdSourcing } from "../../CrowdSourcing";
import { SC } from "../../../lib/settings";
export var Settings;
(function (Settings) {
    function normalize(settings) {
        if (!settings)
            settings = { teleport_customization: undefined, solving: undefined, crowdsourcing: undefined, experimental: undefined };
        settings.teleport_customization = TeleportSettings.normalize(settings.teleport_customization);
        settings.solving = ClueSolving.Settings.normalize(settings.solving);
        settings.crowdsourcing = CrowdSourcing.Settings.parse(settings.crowdsourcing);
        settings.experimental = Settings.ExperimentalSettings.parse(settings.crowdsourcing);
        return settings;
    }
    Settings.normalize = normalize;
    let TeleportSettings;
    (function (TeleportSettings) {
        function empty() {
            return {
                potas: [],
                presets: [{
                        id: 0,
                        fixed: true,
                        name: "Default",
                        fairy_ring_favourites: new Array(10).fill(null),
                        active_potas: ["red", "green", "yellow", "purple"]
                    }],
                active_preset: 0,
                preset_bindings: {
                    easy: null, elite: null, hard: null, master: null, medium: null, tetracompass: null, sandy: null
                },
                preset_bindings_active: false
            };
        }
        TeleportSettings.empty = empty;
        function clueChasersRecommendations() {
            return {
                "potas": [
                    {
                        "color": "green",
                        "slots": [
                            {
                                "group_id": "skillsnecklace",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "amuletofglory",
                                "access_id": "necklace"
                            },
                            {
                                "group_id": "combatbracelet",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "delversanklet",
                                "access_id": "anklet"
                            },
                            {
                                "group_id": "ringofslaying",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "travellersnecklace",
                                "access_id": "ring"
                            }
                        ]
                    },
                    {
                        "color": "red",
                        "slots": [
                            {
                                "group_id": "enlightenedamulet",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "ringofrespawn",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "ringofduelling",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "gamesnecklace",
                                "access_id": "necklace"
                            },
                            {
                                "group_id": "ringofwealth",
                                "access_id": "ring"
                            },
                            {
                                "group_id": "digsitependant",
                                "access_id": "ring"
                            },
                        ]
                    }
                ],
                "presets": [
                    {
                        "id": 0,
                        "fixed": true,
                        "name": "Default",
                        "fairy_ring_favourites": [
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        "active_potas": ["red", "green", "yellow", "purple"]
                    },
                    {
                        "id": -1,
                        "name": "Easy Recommendation",
                        "active_potas": [
                            "red",
                            "green"
                        ],
                        "fairy_ring_favourites": [
                            "AIQ",
                            "DIS",
                            "CJR",
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ]
                    },
                    {
                        "id": -2,
                        "name": "Medium Recommendation",
                        "active_potas": [
                            "red",
                            "green"
                        ],
                        "fairy_ring_favourites": [
                            "AIQ",
                            "AJR",
                            "AKS",
                            "ALS",
                            "BKR",
                            "CIP",
                            "CKS",
                            "CLS",
                            "DJP",
                            "DKP"
                        ]
                    },
                    {
                        "id": -3,
                        "name": "Hard Recommendation",
                        "active_potas": [
                            "red",
                            "green"
                        ],
                        "fairy_ring_favourites": [
                            "ALQ",
                            "DKS",
                            "DJP",
                            "CKS",
                            "CKR",
                            "CJS",
                            "BKR",
                            "AKQ",
                            "ALP",
                            null
                        ]
                    },
                    {
                        "id": -4,
                        "name": "Elite Recommendation",
                        "active_potas": [
                            "red",
                            "green"
                        ],
                        "fairy_ring_favourites": [
                            "AJR",
                            "AKQ",
                            "AKS",
                            "ALQ",
                            "BKR",
                            "CJR",
                            "CJS",
                            "CKQ",
                            "CKR",
                            "DLQ"
                        ]
                    },
                    {
                        "id": -5,
                        "name": "Master Recommendation",
                        "active_potas": [
                            "green"
                        ],
                        "fairy_ring_favourites": [
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ]
                    }
                ],
                "active_preset": 0,
                "preset_bindings": {
                    "easy": -1,
                    "medium": -2,
                    "hard": -3,
                    "elite": -4,
                    "master": -5,
                    "tetracompass": null,
                    "sandy": null
                },
                "preset_bindings_active": true
            };
        }
        TeleportSettings.clueChasersRecommendations = clueChasersRecommendations;
        function normalize(settings) {
            if (!settings)
                settings = empty();
            if (!settings.potas)
                settings.potas = [];
            if (!Array.isArray(settings.presets) || settings.presets.length == 0)
                settings.presets = empty().presets;
            if (!settings.presets.some(p => p.id == settings.active_preset))
                settings.active_preset = settings.presets[0].id;
            settings.preset_bindings = {
                easy: null,
                medium: null,
                hard: null,
                elite: null,
                master: null,
                tetracompass: null,
                sandy: null,
                ...(settings.preset_bindings ?? {})
            };
            return settings;
        }
        TeleportSettings.normalize = normalize;
        function inferActiveCustomization(settings) {
            if (!settings)
                debugger;
            const active_preset = settings.presets.find(p => p.id == settings.active_preset);
            return {
                fairy_ring_favourites: active_preset?.fairy_ring_favourites ?? [],
                pota_slots: active_preset?.active_potas?.flatMap(color => {
                    const pota = settings.potas.find(p => p.color == color);
                    if (!pota)
                        return [];
                    return pota.slots.map((slot, i) => {
                        return {
                            jewellry: slot,
                            pota: {
                                color: color,
                                slot: i + 1
                            }
                        };
                    }).filter(p => p.jewellry);
                }) ?? []
            };
        }
        TeleportSettings.inferActiveCustomization = inferActiveCustomization;
    })(TeleportSettings = Settings.TeleportSettings || (Settings.TeleportSettings = {}));
    let PotaColor;
    (function (PotaColor) {
        PotaColor.values = ["red", "green", "yellow", "purple"];
        function iconUrl(color) {
            return `assets/icons/teleports/pota_${color}.png`;
        }
        PotaColor.iconUrl = iconUrl;
    })(PotaColor = Settings.PotaColor || (Settings.PotaColor = {}));
    Settings.ExperimentalSettings = SC.object({
        alt1gl_enabled: SC.boolean(false),
    });
})(Settings || (Settings = {}));
